import { defineComponent, ref } from 'vue';
import sys from '../../system';

import {
    brands, regular
} from '@truckdown/jsclient/icons';

sys.fontLibrary.add(brands.faFacebook);
sys.fontLibrary.add(brands.faTwitter);
sys.fontLibrary.add(regular.faCopyright);

export default defineComponent({
    name: 'primary-footer',
    props: {},
    setup: function () {

        const isPlanRV = ref<boolean>(sys.framework.context.sys == 'planrv');
        const year = ref<number>(new Date().getFullYear());

        return {
            isPlanRV,
            year
        };
    }
});
